import { render } from "./PosPreviewReceipt.vue?vue&type=template&id=d2ad9c1c&scoped=true&ts=true"
import script from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"
export * from "./PosPreviewReceipt.vue?vue&type=script&lang=ts"

import "./PosPreviewReceipt.vue?vue&type=style&index=0&id=d2ad9c1c&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ad9c1c"]])

export default __exports__